




























































































































































import { Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';

import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import AddGenerarMovimiento from './AddGenerarMovmiento.vue';

import {
  ParamsApi,
  ClearParam,
  MsgParam,
  IdParams,
  DataApi,
  FilterApi,
  FindFilter,
} from './models/Add.model';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { fetchAdd } from './fetchAdd';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import AddModalVerDetalle from './AddModalVerDetalle.vue';
import AddModalAgregarEquipos from './AddModalAgregarEquipos.vue';
import AddModalGenerarRecepcion from './AddModalGenerarRecepcion.vue';
import AddGenerarEncomienda from './AddGenerarEncomienda.vue';
import NDVModalTabs from './NVDModalTabs.vue';
import ModalVerDetalleCrm from './ModalVerDetalleCrm.vue';

@Component({
  components: {
    FormFieldsContainer,
    DatePicker,
    Confirmation,
    MantenedorGridSinCodigo,
    PopUpGeneratedReports,
    AddModalVerDetalle,
    AddModalAgregarEquipos,
    AddModalGenerarRecepcion,
    AddGenerarMovimiento,
    AddGenerarEncomienda,
    NDVModalTabs,
    ModalVerDetalleCrm,
  },
})
export default class AddBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Add;

  verDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  generarRecepcion: PermisoAccion = {
    accionCodigo: 124,
    visible: false,
  };

  agregarEquipos: PermisoAccion = {
    accionCodigo: 125,
    visible: false,
  };

  generarMovimiento: PermisoAccion = {
    accionCodigo: 132,
    visible: false,
  };

  generarEncomienda: PermisoAccion = {
    accionCodigo: 134,
    visible: false,
  };

  readonly accionesTotales: PermisoAccion[] = [
    this.verDetalle,
    this.generarRecepcion,
    this.agregarEquipos,
    this.generarMovimiento,
    this.generarEncomienda,
  ];

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  serverSide: any = null;

  activateChangeFn: boolean = false;
  showModalViewDetail: boolean = false;
  showModalDevices: boolean = false;
  showModalReception: boolean = false;
  showPopUpReport: boolean = false;
  AltaCrm_Seleccionada: any;
  NombreAlta: any;

  now: string = moment().format('YYYY-MM-DD');
  msgReport: string = '';

  data: DataApi = {};
  filterApi: FilterApi = {};
  objParam: ParamsApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    nombre_add: '',
    nombre_alta: '',
    nombre_ndv: '',
    configid: '',
    nombre_tecnico: '',
  };
  timeout: { timeout: number } = { timeout: 3000 };
  dialogGenerarMovimiento: boolean = false;
  dialogGenerarEncomienda: boolean = false;
  showModalNDV: boolean = false;
  showModalAltas: boolean = false;

  actions() {
    actionsEvent.onVerDetalle(this.handleViewDetail);
    actionsEvent.onAgregarEquipos(this.handleAddEquipment);
    actionsEvent.onGenerarRecepcion(this.handleGenerateReception);
    actionsEvent.onGenerarMovimiento(this.handleGenerarMovmiento);
    actionsEvent.onGenerarEncomienda(this.handleGenerarEncomienda);
  }

  constructor() {
    super();
    this.actions();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,

      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
    };
  }

  colsGrid(): ColDef[] {
    const cols = [
      { field: 'Actividad Despacho', id: 'nombre_add', width: 180 },
      { field: 'Fecha Creación', id: 'fecha_creacion', width: 180 },
      { field: 'Nombre Alta', id: 'nombre_alta', width: 150 },
      { field: 'Nota de Venta', id: 'nombre_ndv', width: 150 },
      { field: 'Técnico', id: 'nombre_tecnico', width: 180 },
      { field: 'Propietario', id: 'nombre_propietario', width: 180 },
      {
        field: 'Tipo de Instalación',
        id: 'nombre_tipo_instalacion',
        width: 180,
      },
      { field: 'Tipo de Envio', id: 'nombre_tipo_envio', width: 180 },
      { field: 'Tipo de Despacho', id: 'nombre_tipo_despacho', width: 180 },
      { field: 'Cantidad de Equipos', id: 'cantidad_equipos', width: 180 },
      { field: 'Fecha Recepción', id: 'fecha_recepcion', width: 180 },
      { field: 'Despachado Por', id: 'despachado_por', width: 180 },
      { field: 'Fecha Despacho', id: 'fecha_despacho', width: 180 },
      { field: 'Recepcionado Por', id: 'recepcionado_por', width: 180 },
      { field: 'Estado CRM', id: 'estado', width: 180 },
      { field: 'Razon del Estado', id: 'razon_estado', width: 180 },
      { field: 'Cliente', id: 'cliente', width: 180 },
      {
        field: 'Fecha Recepción en Conecta',
        id: 'fecha_recepcion_conecta',
        width: 180,
      },
      {
        field: 'Recepcionado Por en Conecta',
        id: 'recepcionado_por_conecta',
        width: 180,
      },
      { field: 'Estado en Conecta', id: 'estado_conecta', width: 180 },
      { field: 'Número de Encomienda', id: 'numero_despacho', width: 180 },
      { field: 'Glosa Transmisión', id: 'datos_transmision', width: 180 },
      { field: 'Observaciones', id: 'observaciones', width: 180 },
      {
        field: 'Obs. Dirección Despacho',
        id: 'observaciones_direccion_despacho',
        width: 180,
      },
    ];

    return cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      width: col.width,
      minWidth: 100,
      cellRenderer: params => {
        if (
          params.colDef.field === 'nombre_ndv' ||
          params.colDef.field === 'nombre_alta' ||
          params.colDef.field === 'nombre_add'
        ) {
          var span = document.createElement('span');
          span.textContent = params.value;
          span.style.cursor = 'pointer';
          span.style.color = 'blue';
          span.style.textDecoration = 'underline';
          span.title = 'Haz clic para ver';
          span.onclick = () => {
            if (params.colDef.field === 'nombre_ndv') {
              console.log('Span clickeado:', params.data);
              this.data = params.data;
              this.showModalNDV = true;
            }
            if (params.colDef.field === 'nombre_alta') {
              console.log('Span clickeado:', params.data);
              this.AltaCrm_Seleccionada = params.data.altaid;
              this.NombreAlta = params.data.nombre_alta;
              this.showModalAltas = true;
            }
            if (params.colDef.field === 'nombre_add') {
              console.log('Span clickeado:', params.data);
              this.data = { ...params.data };
              this.showModalViewDetail = true;
            }
          };
          return span;
        } else {
          return params.value;
        }
      },
    }));
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.filterApi = await this.getFilters();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    const self = this;

    this.serverSide = {
      async getRows(params: any): Promise<void> {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        const objectApi = { ...self.objParam, ...params.request };
        self.loadingService.showLoading();
        try {
          const resp = await fetchAdd({ body: { ...objectApi } });

          const {
            CODIGO_RESPUESTA,
            MENSAJE_RESPUESTA,
            LISTA,
            TOTAL,
          } = resp.data;
          const cod: number = Number(CODIGO_RESPUESTA);
          if (cod !== 1 || MENSAJE_RESPUESTA) {
            params.successCallback([{}], 0);
            self.gridApi.showNoRowsOverlay();
            throw new Error(MENSAJE_RESPUESTA);
          }
          params.successCallback([...LISTA], TOTAL);
        } catch (err) {
          if (
            err instanceof Error &&
            err.message &&
            err.message !== 'Network Error'
          ) {
            self.$snotify.error(err.message, { ...self.timeout });
            return;
          }
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { ...self.timeout }
          );
        } finally {
          self.loadingService.hideLoading();
        }
      },
    };
    this.reloadGrid({});
  }

  async reloadGrid({ clear = false }: ClearParam): Promise<void> {
    clear && this.clear();
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }
  setupClickHandler() {
    const gridContainer = this.$refs.gridContainer as Element;
    if (gridContainer) {
      gridContainer.addEventListener('click', event => {
        alert('click');
        const target =
          event.target &&
          (event.target as HTMLElement).closest('.clickable-cell');
        if (target) {
          const value = (target as HTMLElement).dataset.value;
          this.cellClicked(value);
        }
      });
    }
  }
  cellClicked(value: string) {
    // Lógica a ejecutar cuando se hace clic en la celda
    console.log('Celda clickeada:', value);
    // Aquí puedes agregar lo que necesites hacer, como abrir un modal, etc.
  }

  handleFilters(): void {
    this.activateChangeFn && this.reloadGrid({});
  }

  handleSearchFilter(): void {
    this.activateChangeFn = true;
    this.reloadGrid({});
  }

  handleViewDetail(params: { data: DataApi }): void {
    this.data = { ...params.data };
    this.showModalViewDetail = true;
  }

  handleAddEquipment(params: { data: DataApi }): void {
    this.data = { ...params.data };
    this.showModalDevices = true;
  }

  handleGenerateReception(params: { data: DataApi }): void {
    const estado_conecta: string = params.data.estado_conecta
      ? params.data.estado_conecta.toLocaleLowerCase()
      : '';
    if (estado_conecta === 'pendiente') {
      this.$snotify.error(
        'Para generar una recepción es necesario que el estado en conecta este activo',
        { ...this.timeout }
      );
      return;
    }
    this.data = { ...params.data };
    this.showModalReception = true;
  }

  async handleGenerarMovmiento(params: { data: DataApi }): Promise<void> {
    try {
      this.loadingService.showLoading(null, 'handleGenerarMovmiento');
      const result = await fetchAdd({
        endpoint: 'get_devices',
        body: {
          existing_devices: true,
          ...params.data,
        },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1 || MENSAJE_RESPUESTA || LISTA.length === 0) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.data = { ...params.data };
      this.dialogGenerarMovimiento = true;
    } catch (err) {
      console.error('Error: ', err);
    } finally {
      this.loadingService.hideLoading('handleGenerarMovmiento');
    }
  }

  async handleGenerarEncomienda(params: { data: DataApi }): Promise<void> {
    this.data = { ...params.data };
    if (!params.data.nombre_tecnico) {
      this.$snotify(
        'No se ha encontrado un técnico asignado a la actividad de despacho',
        { timeout: 3000 }
      );
      return;
    }
    try {
      const result = await fetchAdd({
        endpoint: 'update_tecnico',
        body: {
          nombre_tecnico: params.data.nombre_tecnico,
          tecnicoid: params.data.tecnicoid,
          id_add: params.data.id,
        },
      });

      const {
        MENSAJE_RESPUESTA,
        CODIGO_RESPUESTA,
        NEW_TECNICO_ID,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      if (NEW_TECNICO_ID) {
        this.data.tecnicoid = NEW_TECNICO_ID;
        this.reloadGrid({});
      }
      this.dialogGenerarEncomienda = true;
    } catch (error) {
      console.error('Error buscando el técnico: ', error);
    }
  }

  handleClosedModal(reload: boolean = false): void {
    // Remover las acciones para evitar bucles de notificaciones
    actionsEvent.removeListeners();
    // Volver a llamarlas
    this.actions();
    this.showModalViewDetail = false;
    this.showModalDevices = false;
    this.showModalReception = false;
    this.dialogGenerarMovimiento = false;
    this.dialogGenerarEncomienda = false;
    this.showModalNDV = false;
    this.showModalAltas = false;
    this.data = {};
    if (reload) {
      this.reloadGrid({});
    }
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  clear(): void {
    const dateValues = {
      start_date: moment().subtract(1, 'month'),
      end_date: moment(),
    };
    // Limpiar el objeto
    Object.keys(this.objParam).forEach(
      key =>
        (this.objParam[key as keyof ParamsApi] =
          dateValues[key as keyof typeof dateValues] || '')
    );
    this.activateChangeFn = false;
  }

  @Watch('objParam.start_date')
  startDateChange() {
    if (this.objParam.start_date > this.objParam.end_date) {
      this.objParam.end_date = this.objParam.start_date;
    }
    this.handleFilters();
  }

  @Watch('objParam.end_date')
  endDateChange() {
    if (this.objParam.end_date < this.objParam.start_date) {
      this.objParam.start_date = this.objParam.end_date;
    }
    this.handleFilters();
  }

  async getFilters(): Promise<FilterApi> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchAdd({ endpoint: 'get_filters' })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, FILTER } = response.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1 || MENSAJE_RESPUESTA) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        return { ...FILTER };
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { ...self.timeout });
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { ...self.timeout }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading());
  }

  findFilter({ list, id, val, propName }: FindFilter): string {
    const foundItem: any = list.find((x: any) => x[id].includes(val));
    return foundItem ? foundItem[propName] : '';
  }

  async getCSV(): Promise<void> {
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');
    this.loadingService.showLoading();
    const configvalor: string = this.objParam.configid
      ? this.findFilter({
          list: this.filterApi.estados,
          id: 'configid',
          val: this.objParam.configid,
          propName: 'configvalor',
        })
      : '';
    const self: this = this;

    return await fetchAdd({
      endpoint: 'export_excel',
      body: {
        userId,
        user,
        configvalor,
        ...self.objParam,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { ...self.timeout });
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { ...self.timeout }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading());
  }
  mounted() {
    this.copy_scroll();
    this.setupClickHandler();
  }
  scrollcopiado: boolean = false;
  copy_scroll() {
    let copyscroll = setInterval(() => {
      const headers = document.querySelectorAll<HTMLElement>(
        '.conecta-add__base_scroll .ag-root-wrapper-body .ag-body-horizontal-scroll'
      );
      if (headers.length > 1) {
        headers[0].remove();
      }
      if (headers.length === 1) {
        const clonedHeader = headers[0].cloneNode(true) as HTMLElement;
        clonedHeader.classList.add('sticky-scroll'); // Agregar la clase para fijar el elemento al hacer scroll
        const rootWrapper = document.querySelector<HTMLElement>(
          '.conecta-add__base_scroll .ag-root-wrapper-body .ag-root.ag-unselectable.ag-layout-auto-height'
        );
        if (rootWrapper === null) {
          return;
        }
        rootWrapper.prepend(clonedHeader);

        // Sincronizar el scroll horizontal entre el header clonado y el original
        const scrollViewports = document.querySelectorAll<HTMLElement>(
          '.conecta-add__base_scroll .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
        );
        scrollViewports[0].addEventListener('scroll', function() {
          scrollViewports[1].scrollLeft = scrollViewports[0].scrollLeft;
        });
        scrollViewports[1].addEventListener('scroll', function() {
          scrollViewports[0].scrollLeft = scrollViewports[1].scrollLeft;
        });
      }
      // Sincronizar los espaciadores
      const rightSpacers = document.querySelectorAll<HTMLElement>(
        '.conecta-add__base_scroll .ag-root-wrapper-body .ag-horizontal-right-spacer'
      );
      rightSpacers[0].style.width = rightSpacers[1].style.width;
      rightSpacers[0].style.minWidth = rightSpacers[1].style.minWidth;
      rightSpacers[0].style.maxWidth = rightSpacers[1].style.maxWidth;

      const scrollContainer = document.querySelectorAll<HTMLElement>(
        '.conecta-add__base_scroll .ag-root-wrapper-body .ag-body-horizontal-scroll-container'
      );
      scrollContainer[0].style.width = scrollContainer[1].style.width;
      scrollContainer[0].style.minWidth = scrollContainer[1].style.minWidth;
      scrollContainer[0].style.maxWidth = scrollContainer[1].style.maxWidth;

      this.scrollcopiado = true;
      clearInterval(copyscroll);
    }, 1000);
  }
}
